import './App.css';
import Header from './components/sections/header/Header';
import Nav from './components/sections/nav/Nav';
import About from './components/sections/about/About';
import Skills from './components/sections/skills/Skills';
// import Experience from './components/sections/experience/Experience';
// import Publications from './components/sections/publications/Publications';
// import Education from './components/sections/education/Education';
// import Certifications from './components/sections/certifications/Certifications';
import Portfolio from './components/sections/portfolio/Portfolio';
import Contact from './components/sections/contact/Contact';
// import Services from './components/sections/services/Services';
// import Testimonials from './components/sections/testimonials/Testimonials';
import Footer from './components/sections/footer/Footer';
import ReactGA from 'react-ga';
import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const TRACKING_ID = "UA-257192680-1"; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID);
ReactGA.pageview(window.location.pathname + window.location.search);

export default function App() {

  const [isVisible, setIsVisible] = useState(false);


  const handleWhatsAppCall = () => {
    const phoneNumber = "+94770882237";
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl, '_blank');
  };



  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);


  return (
    <>
      <Header />
      <Nav />
      <About />
      <Skills />
      <Portfolio />
      {/* <Experience /> */}
      {/* <Certifications /> */}
      {/* <Education /> */}
      {/* <Publications /> */}
      {/* <Services /> */}
      {/* <Testimonials /> */}
      <Contact />
      <Footer />


      <div className="wh-api-bg">
      <div onClick={handleWhatsAppCall}>
      <div className="wh-api">
	<div className="wh-fixed whatsapp-pulse">
			<button className="wh-ap-btn"></button> 
	</div>
</div>
 </div>  
    </div>



    <div className="scroll-up-button">
      {isVisible && (
        <button onClick={scrollToTop}>
          <FaArrowUp />
        </button>
      )}
    </div>

    </>
  );
};
